export enum TrackingConversionType {
  QUALIFIED_USER = 'QUALIFIED_USER',
  IC_START = 'IC_START',
  IC_DONE = 'IC_DONE',
  ADD_TO_CART = 'CART_UPDATE_ADD',
  REMOVE_FROM_CART = 'CART_UPDATE_REMOVE',
  DELETE_FROM_CART = 'CART_UPDATE_DELETE',
  TRANSACTION = 'TRANSACTION',
  NEWSLETTER_SIGNUP = 'NEWSLETTER_SIGNUP',
  CLUB_SURVEY = 'CLUB_SURVEY',
  ACTIVATION_CODE_REQUESTED = 'ACTIVATION_CODE_REQUESTED',
  SERVICE_ACTIVATED = 'SERVICE_ACTIVATED',
  FORM_SUBMIT = 'FORM_SUBMIT',
  INITIATE_PAYMENT = 'INITIATE_PAYMENT',
  // Lowercase on purpose: this value is stored verbatim in the tracking DB and the reporting
  // contract names the conversion `feedback_submit`.
  FEEDBACK_SUBMIT = 'feedback_submit',
  WITHDRAW_ORDER = 'WITHDRAW_ORDER',
  TILE_CLICK = 'TILE_CLICK',
  // Exchange programs (e.g. the Keypad 2 NFC tamper exchange): the prompt opened / an ID was added
  PROGRAM_START = 'PROGRAM_START',
  VERIFICATION_START = 'VERIFICATION_START',
}
